import { render, staticRenderFns } from "./LegalDocumentContent_nsdT2w.vue?vue&type=template&id=694f2546&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_nsdT2w.vue?vue&type=style&index=0&id=694f2546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f2546",
  null
  
)

export default component.exports